module.exports = __webpack_public_path__ + "img/pp-50.a0ef47a5.jpg";